import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    const { personalInfo } = this.props;
    return (
      <div className="projects-title">
        Projects Hi
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectsTitle.js